import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { ReferralComponent } from '@pg-app/partner/referral/containers/referral/referral.component';
import { ReferralRoutingModule } from '@pg-app/partner/referral/referral-routing.module';
import { CoreUiModule } from '@nttp/core-ui';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { DialogUploadReferralComponent } from './dialog-upload-referral/dialog-upload-referral.component';
import { PipeModule } from '@nttp/pipes/pipe.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, CoreMaterialModule, ReferralRoutingModule, CoreUiModule, CommonDialogModule, PipeModule],
  declarations: [ReferralComponent, DialogUploadReferralComponent],
  entryComponents: [DialogUploadReferralComponent]
})
export class ReferralModule { }
